import React from 'react';
import cls from './ModalHeader.module.css';
import classNames from 'classnames';

export const ModalHeader = ({ children }) => {
    return <div className={classNames(cls.customModalHeader)}>{children}</div>;
};
